import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { ColorPicker } from '@syncfusion/ej2-inputs';



export const /** @type {?} */ inputs: string[] = ['columns','cssClass','disabled','enableOpacity','enablePersistence','enableRtl','inline','locale','mode','modeSwitcher','noColor','presetColors','showButtons','value'];
export const /** @type {?} */ outputs: string[] = ['focus', 'blur', 'beforeClose','beforeModeSwitch','beforeOpen','beforeTileRender','change','created','onModeSwitch','open','select','valueChange'];
export const /** @type {?} */ twoWays: string[] = ['value'];
/**
 * Represents the EJ2 Angular ColorPicker Component.
 * ```html
 * <input ejs-colorpicker type='color'/>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class ColorPickerComponent extends ColorPicker implements IComponentBase {
public formCompContext : any;
public formContext : any;
public tagObjects: any;
public valueChange: any;
public focus: any;
public blur: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.formContext  = new FormBase();
        this.formCompContext  = new ComponentBase();
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.formCompContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.formContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.formCompContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.formCompContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: '[ejs-colorpicker]',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ColorPickerComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function ColorPickerComponent_tsickle_Closure_declarations() {
/** @type {?} */
ColorPickerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ColorPickerComponent.ctorParameters;
/** @type {?} */
ColorPickerComponent.prototype.formCompContext;
/** @type {?} */
ColorPickerComponent.prototype.formContext;
/** @type {?} */
ColorPickerComponent.prototype.tagObjects;
/** @type {?} */
ColorPickerComponent.prototype.valueChange;
/** @type {?} */
ColorPickerComponent.prototype.focus;
/** @type {?} */
ColorPickerComponent.prototype.blur;
/** @type {?} */
ColorPickerComponent.prototype.registerEvents;
/** @type {?} */
ColorPickerComponent.prototype.addTwoWay;
/** @type {?} */
ColorPickerComponent.prototype.ngEle;
/** @type {?} */
ColorPickerComponent.prototype.srenderer;
/** @type {?} */
ColorPickerComponent.prototype.viewContainerRef;
/** @type {?} */
ColorPickerComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
